import {ActionBuilder} from "co-redux-builders";
import {Buscador} from "../../model/Buscador";

export default ActionBuilder.build({

    actualizar: (buscador: Buscador) => (buscador),

});